import ApiSignals, { ApiSignalFetchers, BusinessSignals } from "@/apis/api_signals"
import { computed, signal } from "@preact/signals"

const accessTokenSignalSubscribeActive = signal(true)

const accessTokenSignal = computed(() => {
    return ApiSignals.dataSignalAccessToken.value
})

function clearAccessToken() {
    ApiSignals.dataSignalAccessToken.value = ""
}

function setAccessToken(accessToken: string) {
    ApiSignals.dataSignalAccessToken.value = accessToken
}

const isAuthenticatedSignal = computed(() => {
    return Boolean(accessTokenSignal.value) && !!BusinessSignals.isUserLogin.value
})

async function loginWithPassword(countryCode: string, number: string, password: string) {
    await ApiSignalFetchers.fetchDataSignalLoginWithPassword({
        countryCode,
        number,
        password,
    })
}

const otpIdObjectSignal = computed(() => {
    return {
        ...ApiSignals.dataSignalSendOtp.value,
    }
})

async function sendSmsOtp(countryCode: string, number: string) {
    await ApiSignalFetchers.fetchDataSignalSendOtp({
        countryCode,
        phoneNumber: `${countryCode}${number}`,
    })
}

async function loginWithOtp(otpId: string, otpCode: string) {
    await ApiSignalFetchers.fetchDataSignalLoginWithOtp({
        otpId,
        otpCode,
    })
}

async function logout() {
    await ApiSignalFetchers.fetchDataSignalLogout()
    clearAccessToken()
    // 清除GA4中的用户ID
    if (window.clearGA4UserId) {
        window.clearGA4UserId()
    }
}

async function refreshToken() {
    await ApiSignalFetchers.fetchDataSignalRefreshToken()
}

export const Auth = {
    accessTokenSignal,
    otpIdObjectSignal,
    clearAccessToken,
    setAccessToken,
    refreshToken,
    isAuthenticatedSignal,
    loginWithPassword,
    sendSmsOtp,
    loginWithOtp,
    logout,
    accessTokenSignalSubscribeActive,
    turnOnAccessTokenSignalSubscribe() {
        accessTokenSignalSubscribeActive.value = true
    },
    turnOffAccessTokenSignalSubscribe() {
        accessTokenSignalSubscribeActive.value = false
    },
}
